import store from '@/store/index'

export default () => {
  const status = async (status, msg) => {
    store.commit('ACTION_STATUS', status)
    store.commit('ACTION_MESSAGE', msg)
  }

  return {
    status
  }
}
